import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import EndGameMenus from "./EndGameMenus";

const GameIframe = () => {
  const navigate = useNavigate();
  const [showMenus, setShowMenus] = useState(-10);
  const [tgInfo, setTgInfo] = useState({});
  const [link, setLink] = useState(
    process.env.REACT_APP_SWEAT_WEB_URL +
      `/?tg_user_id=${encodeURIComponent(tgInfo.tgUserId)}&game_name=${
        tgInfo.gameName
      }&bot_name=${tgInfo.botName}`
  );
  const [score, setSore] = useState(0);
  const [collectedCount, setCollectedCount] = useState(0);

  const tg_info = JSON.parse(localStorage.getItem("tg_info"));
  useEffect(() => {
    if (tg_info) {
      const tgUserId = tg_info?.tgUserId;
      const gameName = tg_info?.gameName;
      const botName = tg_info?.botName;
      if (tgUserId && gameName && botName) {
        setTgInfo(tg_info);
        setLink(
          process.env.REACT_APP_SWEAT_WEB_URL +
            `/?tg_user_id=${encodeURIComponent(tgInfo.tgUserId)}&game_name=${
              tgInfo.gameName
            }&bot_name=${tgInfo.botName}`
        );
      }
    }
  }, [tgInfo.botName, tgInfo.gameName, tgInfo.tgUserId, tg_info]);

  useEffect(() => {
    window.addEventListener("message", (event) => {
      const data = event.data;
      const { type, text } = data;
      if (type === "finished_game") {
        const result = JSON.parse(text);
        console.log({ result });
        setSore(result.Score || 0);
        setCollectedCount(result.CollectedCount || 0);
        setShowMenus(99);
      }
    });
  }, [navigate]);

  const playAgain = () => {
    const iframe = document.getElementById("game_iframe");
    if (iframe) {
      iframe.contentWindow.postMessage({ type: "play_again", link }, "*");
    }
    setShowMenus(-10);
  };
  return (
    <div className="Game">
      <EndGameMenus
        style={{ zIndex: showMenus }}
        playAgain={playAgain}
        setShowMenus={setShowMenus}
        score={score}
        collectedCount={collectedCount}
      />
      <iframe
        id="game_iframe"
        src={`/game.html?tg_user_id=${tgInfo.tgUserId}&game_name=${tgInfo.gameName}&bot_name=${tgInfo.botName}&backend_url=${process.env.REACT_APP_BACKEND_URL}&sweat_url=${process.env.REACT_APP_SWEAT_URL}&redirect_url=${process.env.REACT_APP_SWEAT_WEB_URL}`}
        width="100%"
        height="100%"
        style={{ border: "none" }}
        allow="clipboard-read; clipboard-write"
        sandbox="allow-modals allow-scripts allow-same-origin allow-popups"
        title="HTML5 Game"></iframe>
    </div>
  );
};

export default GameIframe;
